import BaseView from "scripts/views/baseView";
import VerifyEmailNotificationFormView from "scripts/views/verifyEmailNotificationFormView";
import { alert } from "scripts/alerts/alerts";

import verifyEmailErrorSubPage from "templates/verifyEmailErrorSubPage.hbs";

class VerifyEmailPageView extends BaseView {
  get template() {
    return verifyEmailErrorSubPage;
  }

  initialize() {
    this.verifyEmailNotificationForm = this.addSubView(
      new VerifyEmailNotificationFormView({
        emailAddress: this.model.emailAddress,
      }),
    );

    this.verifyEmailNotificationForm.on("success", this.onSuccess, this);
    this.verifyEmailNotificationForm.on("failure", this.onFailure, this);
  }

  render() {
    this.$el.html(this.template());

    this.verifyEmailNotificationForm
      .appendTo(this.$el.find("#bb-email-verification-page-resend-form-region"))
      .render();

    return this;
  }

  onSuccess() {
    alert("Email sent!", "Check your inbox!", "success").show();
  }

  onFailure() {
    alert(
      "Oops",
      "That didn't work. Please contact support if the problem persists.",
      "error",
    ).show();
  }
}

export default VerifyEmailPageView;
